import http from '../../integration/HttpService';
const apiUrl = require('../../config').get(process.env.REACT_APP_ENV).apiUrl;
const apiBase = apiUrl + '/reports/projectReport/'

/**
 * getProjectAndCrListData - get Project and CR List Data
 * @returns {object} All Project Data.
 */
export function getProjectAndCrListData() {
  const endPoint = apiBase + '/getProjectAndCrListData';
  return http.get(endPoint);
}

/**
 * getUnfreezeRequestData - get Unfreeze Request Data
 * @returns {object} All Unfreeze Request Data.
 */
export function getUnfreezeRequestData(params) {
  const endPoint = apiBase + '/getUnfreezeRequestData';
  return http.post(endPoint, params);
}

/**
 * getRMAllocationData - get RM Allocation Data
 * @returns {object} RM Allocation Data.
 */
export function getRMAllocationData(params) {
  const endPoint = apiBase + '/getRMAllocationData';
  return http.post(endPoint, params);
}

/**
 * getResourceHolidaysData - get Resource Holidays Data
 * @returns {object} Resource Holidays Data.
 */
export function getResourceHolidaysData(params) {
  const endPoint = apiBase + '/getResourceHolidaysData';
  return http.post(endPoint, params);
}
